import { DetailListStatus } from '../../../LazyComponents';

export const getPeriodoYYYYMM = (path: string): string | null => {
  const listStatus = DetailListStatus.getDetailListStatus(path);
  const periodoDate = listStatus.filters['periodo'];
  return periodoDate ? periodoDate.substring(0, 7) : null;
};

export const sanitizeFileName = (name: string): string => {
  const dot = name.lastIndexOf('.');
  let base = name;
  let ext = '';

  if (dot !== -1) {
    base = name.substring(0, dot);
    ext = name.substring(dot);
  }

  const clean = base
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9_\-\(\)\[\]]/g, '-')
    .toLowerCase();

  return clean + ext.toLowerCase();
};

export const getStatusCircleClass = (estado): string => {
  switch (estado) {
    case false:
      return 'status-films__circle--red';
    case true:
      return 'status-films__circle--green';
    default:
      return 'status-films__circle--yellow';
  }
};

export const getNext10Years = (): number[] => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: 10 }, (_, i) => currentYear - i);
};
